<kendo-tabstrip (tabSelect)="onTabSelected($event)" [animate]="false" class="sam-padding">
   <kendo-tabstrip-tab
      *ngFor="let item of brickCategoriesTabs$ | async; let i = index"
      [selected]="i === (selectedTabIndex$ | async)"
   >
      <ng-template kendoTabTitle>
         <fa-icon
            *ngIf="item.itemRepresentationValue"
            style="margin-right: 10px"
            [icon]="item.itemRepresentationValue.categoryIcon"
         ></fa-icon>
         {{ item.titleTranslationKey | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <div fxLayout="column" [style.height]="'100%'">
            <samweb-searchbar
               [searchValue$]="brickDefinitionSearchInput$"
               (searchValueChanged)="searchTextChanged($event)"
            >
            </samweb-searchbar>
            <kendo-panelbar
               fxFlex="1 1 90%"
               *ngIf="(brickDefinitions$ | async).length > 0"
               (stateChange)="panelBarSelectionOccurred($event)"
               [selectable]="false"
               expandMode="single"
               class="sam-panelbar-icon-hide"
            >
               <kendo-panelbar-item
                  [id]="brickDefinition.brickDefinitionId"
                  [expanded]="(selectedBrickDefinitionId$ | async) === brickDefinition.brickDefinitionId"
                  [selected]="(selectedBrickDefinitionId$ | async) === brickDefinition.brickDefinitionId"
                  title=""
                  *ngFor="let brickDefinition of brickDefinitions$ | i18nSort: 'brickTitleTranslationKey' | async"
               >
                  <ng-template kendoPanelBarItemTitle>
                     <div fxLayout="column" fxFill>
                        <div fxLayout="row">
                           <div fxFlex="1 1 auto" fxFlexAlign="center" class="brick-icon">
                              <fa-layers [fixedWidth]="true" size="2x" kendoTooltip>
                                 <div class="fa-layers sam-center">
                                    <fa-icon [icon]="brickDefinition.brickIcon"></fa-icon>
                                    <fa-icon
                                       *ngIf="brickDefinition.brickSubIcon"
                                       [icon]="brickDefinition.brickSubIcon"
                                       class="brick-definition-subicon"
                                    ></fa-icon>
                                 </div>
                                 <fa-layers-counter
                                    *ngIf="
                                       (numberOfBricksOnWallForBrickDefinition$(brickDefinition.brickDefinitionId)
                                          | async) > 0
                                    "
                                    [title]="
                                       'brick.brick-management.brick-count-title'
                                          | translate
                                             : {
                                                  number:
                                                     (numberOfBricksOnWallForBrickDefinition$(
                                                        brickDefinition.brickDefinitionId
                                                     ) | async)
                                               }
                                    "
                                    content="{{
                                       numberOfBricksOnWallForBrickDefinition$(brickDefinition.brickDefinitionId)
                                          | async
                                    }}"
                                 ></fa-layers-counter>
                              </fa-layers>
                           </div>
                           <div fxFlex="1 1 85%" fxLayout="column">
                              <div fxLayout="row" class="brick-title sam-margin">
                                 <span
                                    [innerHtml]="
                                       brickDefinition.brickTitleTranslationKey
                                          | translate
                                          | highlightText$: brickDefinitionSearchInput$:true
                                          | async
                                          | safeHtml
                                    "
                                 >
                                 </span>
                              </div>
                              <div fxLayout="row" class="sam-margin">
                                 <span
                                    [innerHtml]="
                                       brickDefinition.brickDescriptionTranslationKey
                                          | translate
                                          | highlightText$: brickDefinitionSearchInput$:true
                                          | async
                                          | safeHtml
                                    "
                                 >
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </ng-template>
                  <ng-template kendoPanelBarContent>
                     <samweb-brick-definition-item
                        [addingBrickSpecialHandlingByOtherBrickInstanceId]="
                           addingBrickSpecialHandlingByOtherBrickInstanceId
                        "
                        [brickDefinitionId]="brickDefinition.brickDefinitionId"
                     ></samweb-brick-definition-item>
                  </ng-template>
               </kendo-panelbar-item>
            </kendo-panelbar>

            <ng-template [ngIf]="(brickDefinitions$ | async).length === 0">
               <div fxFlex="1 1 90%" class="sam-margin">
                  <fa-icon fxLayout="row" [icon]="noResultsIcon" size="2x" fxLayoutAlign="center"></fa-icon>
                  <span fxLayout="row" fxLayoutAlign="center" class="sam-margin">
                     {{ 'common.no-search-result-found' | translate }}
                  </span>
               </div>
            </ng-template>
         </div>
      </ng-template>
   </kendo-tabstrip-tab>
</kendo-tabstrip>
